import {Route, Router} from "router5";
import {PageType} from "kbd/enum/PageType";
import Platform from "platform/Platform";
import {TSMap} from "typescript-map";

export class Routes {

    private static activators: TSMap<PageType, () => () => boolean> = new TSMap();
    private static blocker: () => () => boolean = () => () => {
        return false;
    };

    private static ROUTES: Route[] = [
        // OnBoard Routes
        {name: PageType.SignUp, path: "/sign-up"},
        {name: PageType.Login, path: "/login"},
        {name: PageType.ForgotPassword, path: "/forgot-password"},
        {name: PageType.ResetPassword, path: "/reset-password"},
        {name: PageType.CheckInbox, path: "/check-inbox"},
        {name: PageType.ChangePassword, path: "/change-password"},
        // Kyc Routes
        {name: PageType.KycWelcome, path: "/kyc-welcome?action&theme"},
        {name: PageType.KycPersonalInfo, path: "/kyc-personal-info?action&theme"},
        {name: PageType.KycAddress, path: "/kyc-address?action&theme"},
        {name: PageType.KycFinancialDetails, path: "/kyc-financial-details?action&theme"},
        {name: PageType.KycTradingFamiliarity, path: "/kyc-trading-familiarity?action&theme"},
        {name: PageType.KycTradingExperience, path: "/kyc-trading-experience?action&theme"},
        {name: PageType.KycTradingExperienceKnowledge, path: "/kyc-trading-experience-knowledge?action&theme"},
        {name: PageType.KycTradingExperienceKnowledge2, path: "/kyc-trading-experience-knowledge-2?action&theme"},
        {name: PageType.KycTradingExperienceIntentions, path: "/kyc-trading-experience-intentions?action&theme"},
        {name: PageType.KycIdentityVerification, path: "/kyc-identity-verification?action&theme"},
        {name: PageType.KycAddressVerification, path: "/kyc-proof-of-address?action&theme"},
        {name: PageType.KycPaymentVerification, path: "/kyc-payment-verification?action&theme"},
        {name: PageType.KycTradingProfile, path: "/kyc-trading-profile?action&theme"},
        {name: PageType.KycSignature, path: "/kyc-signature?action&theme"},
        {name: PageType.KycCongratulation, path: "/kyc-congratulation?action&theme"},
        {name: PageType.KycAppropriate, path: "/kyc-appropriate?action&theme"},
        {name: PageType.KycInAppropriate, path: "/kyc-in-appropriate?action&theme"},
        {name: PageType.KycFilledOut, path: "/kyc-filled-out?action&theme"},
        {name: PageType.KycCnmv, path: "/kyc-cnmv?action&theme"},
        // Deposit Routes
        {name: PageType.DepositTopUp, path: "/deposit-top-up?action&theme"},
        // Professional Routes
        {name: PageType.ProfessionalWelcome, path: "/professional-welcome?theme"},
        {name: PageType.ProfessionalQuestionnaire, path: "/professional-questionnaire?theme"},
        {name: PageType.ProfessionalIllegal, path: "/professional-illegal?theme"},
        {name: PageType.ProfessionalSuccessful, path: "/professional-successful?theme"},
        {name: PageType.ProfessionalDocuments, path: "/professional-documents?theme"},
        // Documents Routes
        {name: PageType.DocumentsOverview, path: "/documents-overview?theme"},
        {name: PageType.DocumentPage, path: "/document-page?theme"},
        {name: PageType.DocumentPaymentPage, path: "/document-payment-page?theme"},
        // Deposit limits Routes
        {name: PageType.DepositLimitQuestions, path: "/deposit-limits?theme"},
        {name: PageType.DepositLimitSuccessful, path: "/deposit-limits-successful?theme"},
        {name: PageType.DepositLimitAlreadyFilled, path: "/deposit-limits-filled?theme"},
        {name: PageType.DepositLimitWarning, path: "/deposit-limits-warning?theme"},
        // Share information Routes
        {name: PageType.ShareInformationNotice, path: "/share-information-notice?theme"},
        {name: PageType.ShareInformationDetails, path: "/share-information-details?theme"},
    ];

    private constructor() {
    }

    public static routes(): Route[] {
        return this.ROUTES;
    }

    public static addActivator(pageType: PageType, activator: () => () => boolean): void {
        if (pageType && activator) {
            this.activators.set(pageType, activator);
            const router: Router = Platform.router().router();
            router.canActivate(pageType, activator);
        }
    }

    public static canActivate(pageType: PageType): boolean {
        const activator: () => () => boolean = this.activators.get(pageType);
        if (activator) {
            return activator()();
        }
        return true;
    }

    public static blockAllExcept(pageType: PageType): void {
        Routes.ROUTES.forEach((route: Route) => {
            if (route.name !== pageType) {
                this.addActivator(route.name as PageType, this.blocker)
            }
        });
    }
}
